import get from 'lodash.get';

import type {
  ConfirmErrorParams,
} from '../showConfirm';

export function processError<ErrorType = Error>(
  error: ErrorType,
  errorsPath: string,
): ConfirmErrorParams {
  const errorsObject = get(error, errorsPath) as string | string[];

  if (typeof errorsObject === 'string') {
    return {
      title: errorsObject,
    };
  }

  if (Array.isArray(errorsObject)) {
    if (errorsObject.length === 1) {
      return {
        title: errorsObject[0],
      };
    }

    return {
      message: errorsObject.map((message, index) => (
        <div key={index}>
          {message}
        </div>
      )),
    };
  }

  return errorsObject;
}
